export const RECAPTCHA_SITE_VERIFY_URL = 'https://www.google.com/recaptcha/api/siteverify';
export const RECAPTCHA_SITE_KEY = '6LeL4r0UAAAAAOUyyiNVqzhyOmSTv2GpsM9ScG-d';
export const RECAPTCHA_SECRET_KEY = '6LeL4r0UAAAAAOuxOxvLzA6nAdpSYmQsOym4b76S';